import { Container, Tab, Nav, Row, Col } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TitleComponent from "../../components/TitleComponent/TitleComponent";
import EditSuperAdminProfile from "../../components//profileSetting/superAdmin/EditSuperAdminProfile";
import EditAdminProfile from "../../components//profileSetting/Admin/EditAdminProfile";
import EditManagerProfile from "../../components//profileSetting/Manager/EditManagerProfile";
import ChangePassword from "./ChangePassword";
// import './ProfileSecurityComponent.css';
// import Settings from '../Settings';
import Loader from "../../assets/images/loader.gif";
import { handleGetUserProfile } from "../../store/actions/userActions";

const ProfileSetting = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("profile");
  const { user,  isLoading } = useSelector((state) => state.user);

  useEffect(() => {
    if (user?.id) {
      handleGetUserProfile(user.id, dispatch);
    }
  }, [user?.id, dispatch]);

  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }
  return (
    <Container>
      <Row>
        <Col lg={12} className="component-container mb-2">
          <Row className="mb-3">
            <Col xs={6}>
              <TitleComponent title="Settings" />
            </Col>
          </Row>

          <Tab.Container
            activeKey={activeTab}
            onSelect={(tab) => setActiveTab(tab)}
          >
            <Nav variant="tabs">
              <Nav.Item>
                <Nav.Link eventKey="profile">Profile</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="security">Security</Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              {/* Profile Tab */}
              <Tab.Pane eventKey="profile">
                <Row>
                  <Col>
                    {user?.role === "superadmin" ? (
                      <EditSuperAdminProfile />
                    ) : user?.role === "manager" ? (
                      <EditManagerProfile />
                    ) : (
                      <EditAdminProfile />
                    )}
                  </Col>
                </Row>
              </Tab.Pane>

              {/* Security Tab */}
              <Tab.Pane eventKey="security">
                <Row>
                  <Col>
                    <ChangePassword />
                  </Col>
                </Row>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Col>
      </Row>
    </Container>
  );
};

export default ProfileSetting;
